import axios from 'axios';

const LogReactError = async (url, error, error_details) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}/log-react-error`,
      {
        url,
        error,
        error_details
      },
      {
        validateStatus: false // This allows us to handle non-200 responses without throwing
      }
    );

    if (response.status !== 200) {
      console.log('Error logging failed:', response.status, response.data);
    }
  } catch (err) {
    console.log('Error while trying to log error:', err);
  }
};

export default LogReactError;
